import { render, staticRenderFns } from "./identify-symbol.vue?vue&type=template&id=27bfdf24&scoped=true&"
import script from "./identify-symbol.vue?vue&type=script&lang=js&"
export * from "./identify-symbol.vue?vue&type=script&lang=js&"
import style0 from "./identify-symbol.vue?vue&type=style&index=0&id=27bfdf24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bfdf24",
  null
  
)

export default component.exports